import SearchIcon from "@mui/icons-material/Search"
import { Box, InputAdornment, OutlinedInput, styled } from "@mui/material"
import { ReactElement } from "react"

import { SEARCH_BAR_ITEM_RADIUS_MULTIPLIER } from "../../themes/defaultThemeParams"

const SearchInputStyle = styled(OutlinedInput)(({ theme }) => ({
    height: "50px",
    width: "80%",
    borderRadius: theme.shape.borderRadius * SEARCH_BAR_ITEM_RADIUS_MULTIPLIER,
    marginLeft: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.background.contentBackground,
    "& input": {
        background: "transparent !important",
        paddingLeft: "4px !important",
    },
    [theme.breakpoints.down("md")]: {
        width: "90%",
        marginLeft: 4,
    },
}))

interface ISearchInputProps {
    value: string
    onClick: () => void
}

/**
 * Styled search input for the application navigation bar
 * @example
 * <SearchInput />
 */
const SearchInput = ({ value, onClick }: ISearchInputProps): ReactElement => (
    <Box
        flexGrow={1}
        sx={{
            display: "block",
        }}
    >
        <SearchInputStyle
            placeholder="Click to start search..."
            value={value}
            onClick={onClick}
            onChange={onClick}
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>
            }
            aria-describedby="search-helper-text"
            inputProps={{ "aria-label": "weight" }}
        />
    </Box>
)

export default SearchInput
